import {Component, Input, OnInit} from '@angular/core';

import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {SmallTextInfoModalComponent} from '../small-text-info-modal/small-text-info-modal.component';
import {ModalDynamicV3Service} from '../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-info-icon-button',
    templateUrl: './info-icon-button.component.html',
    styleUrls: ['./info-icon-button.component.scss']
})
export class InfoIconButtonComponent implements OnInit {


    @Input() public model: { title: string, messages: string[], dialogHeight?: number };
    private dialogRef: IModalDialogV3;

    // private modalVisibilitySub: Subscription;

    constructor(private modalDynamicV3Service: ModalDynamicV3Service,
                private modalVisibilityService: ModalVisibilityService) {
    }

    public ngOnInit() {

    }

    public openInfoPanel(anchor: HTMLElement) {
        if (!this.model) {
            console.warn('dialog content is not defined');
            return;
        }

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('info-icon-button');

        const deltaX = -191;
        const deltaY = 21;

        const expectedDialogHeight = this.model.dialogHeight ? this.model.dialogHeight : 100;

        const top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+anchor.getBoundingClientRect().right) + deltaX;

        this.dialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    ...this.model,
                    top: top,
                    left: left,
                    showCloseBtn: true,
                    minHeight: expectedDialogHeight,
                    closeEvent: this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$,
                }
            }, true);


        // this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
        //     if (this.dialogRef) {
        //         this.dialogRef.close();
        //         this.modalVisibilitySub.unsubscribe();
        //         this.dialogRef = undefined;
        //         this.modalVisibilitySub = undefined;
        //     }
        // });

    }


    // public ngOnDestroy(): void {
    //     if (this.modalVisibilitySub) {
    //         this.modalVisibilitySub.unsubscribe();
    //     }
    // }
}
